import { render, staticRenderFns } from "./BlacklistItem.vue?vue&type=template&id=60033493&scoped=true&"
import script from "./BlacklistItem.vue?vue&type=script&lang=js&"
export * from "./BlacklistItem.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistItem.vue?vue&type=style&index=0&id=60033493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60033493",
  null
  
)

export default component.exports